import * as React from "react";

function SvgMovePlateTo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path d="M34 0H14.167v4.25H29.75v25.5H14.167V34H34V0z" fill="#414042" />
      <path
        d="M0 14.167h11.333v-4.25L18.417 17l-7.084 7.083v-4.25H0v-5.666z"
        fill="#414042"
      />
    </svg>
  );
}

export default SvgMovePlateTo;
